import CryptoJS from "crypto-js";

const secretKey = "your-secret-key";

// Two-way encryption example
const encrypt = (text: string): string => {
  if (!text) return '';
  return CryptoJS.AES.encrypt(text, secretKey).toString();
};

const decrypt = (ciphertext: string): string => {
  if (!ciphertext || ciphertext.trim() === '') {
    return '';
  }
  
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    
    // Check if decryption resulted in empty string, which might indicate invalid ciphertext
    if (!decrypted) {
      console.warn('Decryption resulted in empty string, returning original');
      return ciphertext;
    }
    
    return decrypted;
  } catch (error) {
    console.error('Decryption error:', error);
    console.warn('Returning original value due to decryption failure');
    // Return the original value instead of throwing an error
    return ciphertext;
  }
};

// Generate a hash for a route using SHA-256
const generatePermissionHash = (permission: string): string => {
  const hash = CryptoJS.SHA256(permission).toString(CryptoJS.enc.Hex); // Convert to hex string
  const shortHash = hash.substring(0, 16);
  const uuid = `${shortHash.substring(0, 4)}-${shortHash.substring(4, 8)}-${shortHash.substring(8, 12)}-${shortHash.substring(12, 16)}`;
  return uuid;
};
const testEncryptDecrypt = () => {
  const originalText = "password";
  console.log('Original:', originalText);

  
  const encrypted = encrypt(originalText);
  console.log('Encrypted:', encrypted);
  
  const decrypted = decrypt(encrypted);
  console.log('Decrypted:', decrypted);
  
  console.log('Match:', originalText === decrypted);
};
export { generatePermissionHash, encrypt, decrypt, testEncryptDecrypt };